import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface ResultField {
  label: string;
  value: string;
}

export interface TableColumn {
  header: string;
  key: string;
}

export interface TableData {
  columns: TableColumn[];
  rows: any[];
}

@Component({
  selector: 'app-results-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './results-modal.component.html',
  styleUrl: './results-modal.component.css'
})
export class ResultsModalComponent {
  @Input() isVisible: boolean = false;
  @Input() title: string = 'Resultados';
  @Input() results: ResultField[] = [];
  @Input() tableData: TableData | null = null;
  @Input() headerInfo: string = ''; // Para mostrar info adicional como el NIT
  @Output() closed: EventEmitter<void> = new EventEmitter();

  closeModal() {
    this.isVisible = false;
    this.closed.emit();
  }

  onBackdropClick(event: MouseEvent) {
    if ((event.target as HTMLElement).classList.contains('modal-backdrop')) {
      this.closeModal();
    }
  }

  getNestedValue(obj: any, path: string): any {
    return path.split('.').reduce((prev, curr) => prev?.[curr], obj) || '-';
  }
}
